export default __webpack_public_path__ + "static/media/carousel-next.de1fe876.svg";